// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TrustedClients from "./components/TrustedClients";
import CtaDevis from "./components/CtaDevis";
import WhatsAppButton from "./components/WhatsAppButton";

// Pages
import Home from "./pages/Home";
import Galerie from "./pages/Galerie";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AccesClientsMH from "./pages/AccesClientsMH";
import Instagram from "./pages/Instagram";

// Pages légales
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";

// Styles
import "./index.css";

export default function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* Navigation */}
        <Navbar />

        {/* Contenu principal */}
        <main className="flex-grow" role="main">
          <Routes>
            {/* Accueil */}
            <Route path="/" element={<Home />} />

            {/* Landing Instagram */}
            <Route path="/instagram" element={<Instagram />} />

            {/* Pages principales */}
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Accès clients */}
            <Route path="/acces-clients" element={<AccesClientsMH />} />

            {/* Légal */}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/confidentialite" element={<Confidentialite />} />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/galerie" replace />} />
          </Routes>
        </main>

        {/* CTA devis flottant */}
        <CtaDevis />

        {/* Bouton WhatsApp flottant */}
        <WhatsAppButton />

        {/* Bandeau logos clients */}
        <TrustedClients />

        {/* Pied de page */}
        <Footer />
      </div>
    </Router>
  );
}